module.exports = __webpack_public_path__ + "img/danxuan.a2af6a9d.png";